import { Colors } from '@constants/colors.constants';
import { CircularProgress, Stack, Typography } from '@mui/material';
import { ExecutionCountByServiceKind } from '@store/statistics';
import { ArcElement, Chart as ChartJS, Legend, Tooltip } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Pie } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);
ChartJS.register(ChartDataLabels);

interface ExecutionCountChartProps {
  title: string;
  executionCountByServiceKind?: ExecutionCountByServiceKind[];
  loading: boolean;
  legendFontSize?: number;
}

const ExecutionCountChart = (props: ExecutionCountChartProps) => {
  const {title, executionCountByServiceKind, loading, legendFontSize} = props;

  const sum = executionCountByServiceKind?.reduce((acc, val) => acc + val.execCount, 0) || 1;
  return (
    <Stack
      height="500px"
      bgcolor={Colors.white}
      borderRadius="4px"
      px="3px"
      py="20px"
      justifyContent="space-between"
    >
      <Typography fontSize={18} fontWeight="700" ml="17px">
        {title}
      </Typography>
      {loading && <CircularProgress size={30}/>}
      {!loading && <Stack
          height="400px"
      >
          <Pie
              options={{
                cutout: '0%',
                maintainAspectRatio: false,
                responsive: true,
                offset: 10,
                plugins: {
                  tooltip: {
                    backgroundColor: Colors.background,
                    bodyColor: 'black',
                    cornerRadius: 0,
                    caretSize: 0,
                    bodyAlign: 'right',
                    bodySpacing: 5,
                    displayColors: false,
                    callbacks: {
                      label: (el) => {
                        return `${el.label} : ${el.parsed} tickets`;
                      },
                    },
                    bodyFont: {
                      weight: 'bold',
                      size: 14,
                    },
                  },
                  datalabels: {
                    display: true,
                    anchor: 'center',
                    align: 'center',
                    color: 'white',
                    formatter: function (value) {
                      return ((value / sum) * 100).toFixed(2) + '%';
                    },
                    textStrokeColor: 'black',
                    textStrokeWidth: 2,
                    font: {
                      family: 'CircularStd, sans-serif',
                      size: 14,
                      weight: 'bold'
                    },
                  },
                  legend: {
                    display: true,
                    position: 'left',
                    labels: {
                      font: {
                        family: 'CircularStd, sans-serif',
                        size: legendFontSize ?? 14,
                      },
                    }
                  },
                  title: {display: false},
                },
              }}
              plugins={[ChartDataLabels]}
              data={{
                labels: executionCountByServiceKind?.map((v) => v.serviceKindName) || [],
                datasets: [
                  {
                    data: executionCountByServiceKind?.map((v) => v.execCount) || [],
                    backgroundColor: ['#1984c5', '#22a7f0', '#63bff0', '#a7d5ed', '#e2e2e2', '#e1a692', '#de6e56', '#e14b31', '#c23728']
                  }
                ]
              }}
          /> </Stack>}
    </Stack>
  );
};

export default ExecutionCountChart;
